import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'

import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'

import '@fontsource-variable/inter'
import '@fontsource/roboto-mono/400.css'
import 'primeicons/primeicons.css'
import './styles/tokens.css'
import './styles/main.css'
import { ConsolePreset } from './theme/console'
import './theme/mode'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: ConsolePreset,
    options: {
      // The dark colour scheme follows the theme switch (src/theme/mode.ts).
      darkModeSelector: '[data-theme="dark"]',
    },
  },
})
app.use(ConfirmationService)
app.use(ToastService)
app.use(router)

app.mount('#app')
